module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.489a38a1.svg";